import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-ml-3 p-mr-3 p-d-flex p-ai-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-chevron-left",
  style: {"fontSize":"1.5rem","color":"black"}
}, null, -1 /* HOISTED */)
const _hoisted_3 = {
  class: "p-ml-2",
  style: {"flex":"1"}
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "p-d-flex p-jc-end" }
const _hoisted_6 = { class: "p-d-flex p-jc-end" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h3", { class: "p-ml-3 p-mr-3 p-text-center" }, " Ricorda! Contattaci per cancellare un ordine ", -1 /* HOISTED */)
const _hoisted_8 = { class: "p-mt-2 p-d-flex p-jc-center" }
const _hoisted_9 = { class: "p-mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AddAppointment = _resolveComponent("AddAppointment")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_Card = _resolveComponent("Card")!
  const _component_ExistingAppointments = _resolveComponent("ExistingAppointments")!
  const _component_GvSpinner = _resolveComponent("GvSpinner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Toast, { position: "top-center" }),
    _createVNode(_component_GvSpinner, { "is-loading": _ctx.isLoading }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_router_link, { to: "/csac" }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1 /* STABLE */
          }),
          _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.getTitle), 1 /* TEXT */)
        ]),
        (!_ctx.isPastDate)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_Card, { class: "p-ml-3 p-mr-3 p-p-1 p-shadow-3" }, {
                content: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appointments, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.index
                    }, [
                      _createVNode(_component_AddAppointment, {
                        index: item.index,
                        startFromRoute: _ctx.startFromRoute,
                        endFromRoute: _ctx.endFromRoute,
                        onResult: _ctx.manageResult
                      }, null, 8 /* PROPS */, ["index", "startFromRoute", "endFromRoute", "onResult"]),
                      _createElementVNode("div", _hoisted_5, [
                        (item.index !== 0)
                          ? (_openBlock(), _createBlock(_component_Button, {
                              key: 0,
                              class: "delete_icon",
                              icon: "pi pi-trash",
                              onClick: () => _ctx.removeAppointment(item.index)
                            }, null, 8 /* PROPS */, ["onClick"]))
                          : _createCommentVNode("v-if", true)
                      ]),
                      (item.index !== _ctx.appointments.length - 1)
                        ? (_openBlock(), _createBlock(_component_Divider, { key: 0 }))
                        : _createCommentVNode("v-if", true)
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                footer: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_Button, {
                      onClick: _ctx.backToCSAC,
                      label: "Annulla",
                      class: "cancel_button"
                    }, null, 8 /* PROPS */, ["onClick"]),
                    _createVNode(_component_Button, {
                      class: "gv-button",
                      "data-testid": "add-button",
                      onClick: _ctx.saveAppointments,
                      label: "Conferma",
                      disabled: _ctx.isFormInvalid,
                      style: {"margin-left":".5em"}
                    }, null, 8 /* PROPS */, ["onClick", "disabled"])
                  ])
                ]),
                _: 1 /* STABLE */
              }),
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_Button, {
                  class: "gv-button",
                  onClick: _ctx.addAppointment,
                  label: "Aggiungi fascia oraria"
                }, null, 8 /* PROPS */, ["onClick"])
              ])
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_ExistingAppointments, { appointmentDate: _ctx.startFromRoute }, null, 8 /* PROPS */, ["appointmentDate"])
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["is-loading"])
  ], 64 /* STABLE_FRAGMENT */))
}